import styled from 'styled-components';

const HContainerPrincipal = styled.div`
  width: 100%;
  height: 80px;
  background: #125c5b;
  border-radius: 10px;
  color: #fff;
  text-align: center;
  justify-content: center;
  display: flex;
  align-content: center;
  align-items: center;
`;

const HTitlePrincipal = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  text-align: center;
  margin: 0;
`;

const HContainerAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100;
  margin-top: 5em;
`;

const HAction = styled.div`
  margin-left: 1em;
  margin-right: 1em;
  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(18, 92, 91, 0.3);
  border-radius: 10px;
  max-width: 300px;
  width: 100%;
  min-height: 242px;
`;

const HActionDesc = styled.div`
  background: #125c5b;
  color: #fff;
  min-height: 42px;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  border-radius: 10px 10px 0 0;
  line-height: 23px;
`;

const HActionContent = styled.div`
  padding: 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 200px;
  justify-content: space-between;
`;

const HActionSelect = styled.div`
  background: rgba(18, 92, 91, 0.17);
  border-radius: 10px;
  width: 100%;
  border: none;
  padding: 0 15px;
  font-weight: 600;
  font-size: 1rem;
  line-height: 17px;
  display: flex;
  align-items: center;
  height: 47px;
  color: #125c5b;
  display: flex;
  justify-content: space-between;
`;

const HActionSelectButton = styled.button`
  border: none;
  background-color: transparent;
  * {
    cursor: pointer;
  }
`;

const HBtnAction = styled.button`
  width: 137px;
  height: 44px;
  left: 63px;
  top: 189px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;

  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.1px;
  border: 0;
  text-align: center;
  color: #ffffff;
  background: #125c5b;
  border-radius: 10px;
`;

const HActionContainerButton = styled.div``;

const Home = {
  ContainerPrincipal: HContainerPrincipal,
  TitlePrincipal: HTitlePrincipal,
  ContainerAction: HContainerAction,
  Action: HAction,
  ActionDesc: HActionDesc,
  ActionContent: HActionContent,
  ActionSelect: HActionSelect,
  ActionContainerButton: HActionContainerButton,
  ActionSelectButton: HActionSelectButton,
  BtnAction: HBtnAction,
};

export default Home;
